module.exports = __webpack_public_path__ + "img/sample-hakkirimarugo.cd7bfac0.svg";